const FlechaIzquierda = () => {
  return (
    <svg
      width="33"
      height="24"
      viewBox="0 0 33 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="32.6719"
        y="17.6846"
        width="21.7688"
        height="11.4286"
        rx="2"
        transform="rotate(-180 32.6719 17.6846)"
        fill="white"
      />
      <path
        d="M0.972471 13.5515C-0.0617621 12.7508 -0.0617627 11.1892 0.972471 10.3886L13.6646 0.562714C14.9789 -0.45483 16.8889 0.481965 16.8889 2.14418L16.8889 21.7959C16.8889 23.4581 14.9789 24.3949 13.6646 23.3774L0.972471 13.5515Z"
        fill="white"
      />
    </svg>
  );
};

export default FlechaIzquierda;
